

























































































































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { HeadersDataTable } from "@/typings/vuetify/vDataTable";
import { Banco } from "@/typings/store/plugins/easyFirestore/bancos";
import { ItemsTablaBancos } from "@/typings/components/bancos/tabla";
import "@/helpers/extensions";

@Component
export default class TablaUsuarios extends Vue {
  @Prop() readonly search!: string;
  @Prop() readonly bancos!: Banco[];

  // Paginación reactiva moderna
  options = {
    page: 1,
    itemsPerPage: 10,
    pageCount: 0,
  };

  headerProps = {
    sortIcon: "mdi-chevron-down",
  };

  get pageCount(): number {
    return Math.ceil(this.bancos.length / this.options.itemsPerPage);
  }

  get headers(): HeadersDataTable {
    return [
      { text: "Nombre", value: "nombre", align: "start" },
      { text: "Posición", value: "posicion", align: "center" },
      { text: "", value: "opciones", sortable: false, align: "end" },
    ];
  }

  get items(): ItemsTablaBancos {
    return this.bancos.map((banco) => ({
      nombre: banco.nombre,
      posicion: banco.posicion,
      data: banco,
    }));
  }

  @Emit("abrir-info")
  onAbrirInfo(banco: Banco): Banco {
    return banco;
  }

  @Emit("abrir-editar")
  onAbrirEditar(banco: Banco): Banco {
    return banco;
  }

  @Emit("abrir-eliminar")
  onAbrirEliminar(banco: Banco): Banco {
    return banco;
  }
}
